module.exports = __webpack_public_path__ + "img/profile.055a9197.png";